<template>
  <div>
    <div class="page page__list" v-if="!isChange">
      <search-bar
        @search="onSearch"
        name="ac_code,ac_custname,ac_contact"
        placeholder="输入单号、客户、联系人进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/agent/cust/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.ac_code}}</p>
            <p class="list-item-muted">{{item.ac_contact}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.ac_custname}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.ac_status!='已审核'}"
            >
              {{item.ac_status}}
            </span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}条</label>
      </div>
      <add-button to="/agent/cust_edit" />
    </div>

    <div class="page page__list" v-if="isChange">
      <search-bar
        @search="onSearch"
        name="ac_custname,ac_contact"
        placeholder="输入客户名称、联系人进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/agent/cust_change/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.acc_code}}</p>
            <p class="list-item-muted">{{item.acc_accode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.ac_custname}}</p>
            <p class="list-item-muted">
              {{item.ac_contact}}
            </p>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}条</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isChange: false,
      listUrl: "/api/agent/agentcust/list",
      filters: [
        {
          type: "date",
          name: "agentcust.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "ac_status='未审核'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "ac_status='已审核'"
            },
            {
              value: 3,
              label: "待变更",
              condition: "acc_statuscode='SUBMITTED'"
            },
            {
              value: 4,
              label: "已变更",
              condition: "acc_statuscode='AUDITED'"
            }
          ]
        }
      ],
    }
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isChange = filter.value > 2
      this.listUrl = isChange ? '/api/agent/agentcustchange/list' : '/api/agent/agentcust/list'
      this.filters[0].name = isChange ? 'agentcustchange.createTime' : 'agentcust.createTime'
      this.isChange = isChange ? true : false
      filterBar.initConfig()
      next()
    },
  }
}
</script>